import { render, staticRenderFns } from "./seniorCard.vue?vue&type=template&id=3dc1d37a&scoped=true&"
import script from "./seniorCard.vue?vue&type=script&lang=js&"
export * from "./seniorCard.vue?vue&type=script&lang=js&"
import style0 from "./seniorCard.vue?vue&type=style&index=0&id=3dc1d37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1d37a",
  null
  
)

export default component.exports